import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CruiseItineraryService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCruiseItinerariesFiltered(
    startdate: string | undefined,
    enddate: string | undefined,
    region: string | undefined,
    theme: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CruiseItineraryInfo: JSON = <JSON>(<unknown>{
      startdate: startdate,
      enddate: enddate,
      region: region,
      theme: theme,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetItinerariesFiltered',
      JSON.stringify(CruiseItineraryInfo),
      {
        headers: headers,
      }
    );
  }
}
